import React from 'react';
import { SiteFragment } from '@99designs/apps/spa/pages/create/CreateApp.generated';
import { Role } from '@99designs/site-navigation/consts';

interface CreateContext {
    site?: SiteFragment;
    role: Role;
}

export default React.createContext<CreateContext>({
    role: 'logged-out',
});
